import type { ValueFormatterParams } from "ag-grid-community";

import { Avatar, Flex, Text } from "~/ui";

export const UserCellRenderer = (params: ValueFormatterParams<string>) => {
  const name = (params?.value as string) || "";
  // No profile image available in lean DTO for now
  return (
    <Flex align="center" gap="sm" wrap="nowrap" miw={0}>
      <Avatar radius="xl" size="sm" />
      <Text
        size="sm"
        fw={500}
        truncate
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          minWidth: 0,
        }}
      >
        {name}
      </Text>
    </Flex>
  );
};
